var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import firebase from 'firebase/app';
import { uuid } from './utils';
export class NGAuth {
    constructor(_ngb) {
        this._ngb = _ngb;
    }
    init() {
        if (this._user) {
            this._user = undefined;
        }
    }
    login(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const token = yield this._ngb.api.call('login-uid', this._ngb.cid, uid);
                return this.loginToken(token);
            }
            catch (e) {
                // tslint:disable-next-line
                console.log('e', e);
                throw e;
            }
        });
    }
    loginAnonymously() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.isLoggedIn();
            if (result) {
                return result;
            }
            const token = localStorage.getItem(`${this._ngb.cid}.token`);
            if (token) {
                return this.loginToken(token);
            }
            return this.login(uuid());
        });
    }
    isLoggedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            const user = yield this.isFirebaseLoggedIn();
            if (user && user.uid) {
                const result = yield this.getUserByUID(user.uid);
                if (result && result.isNew) {
                    delete result.isNew;
                    yield this._ngb.db
                        .collection('users')
                        .doc(result.uid)
                        .update({
                        isNew: firebase.firestore.FieldValue.delete(),
                    });
                }
                return result;
            }
            else {
                return;
            }
        });
    }
    loginToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { user } = yield this._ngb.app.auth().signInWithCustomToken(token);
            localStorage.setItem(`${this._ngb.cid}.token`, token);
            return this.getUserByUID(user.uid);
        });
    }
    isAdmin() {
        return new Promise(resolve => this._ngb.db.common
            .doc(`public/clients/${this._ngb.cid}`)
            .get()
            .then(() => resolve(true))
            .catch(() => resolve(false)));
    }
    logout() {
        localStorage.removeItem(`${this._ngb.cid}.token`);
        if (this._ngb.app) {
            return this._ngb.app.auth().signOut();
        }
    }
    getUserByUID(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            if (uid.indexOf(`${this._ngb.cid}.`) === 0) {
                uid = uid.replace(`${this._ngb.cid}.`, '');
            }
            try {
                const snapshot = yield this._ngb.db
                    .collection('users')
                    .doc(uid)
                    .get();
                let result;
                if (snapshot.exists) {
                    const user = snapshot.data();
                    result = this._user = user;
                }
                return result;
            }
            catch (e) {
                console.warn(e);
                return null;
            }
        });
    }
    isFirebaseLoggedIn() {
        return new Promise(resolve => {
            const fn = this._ngb.app.auth().onAuthStateChanged(user => {
                fn();
                resolve(user);
            });
        });
    }
    get user() {
        return this._user;
    }
}
//# sourceMappingURL=NGAuth.js.map